/* Copyright (c) 2018 Scaper */

import * as cx from "classnames";
import * as React from "react";
import { CardElement, injectStripe, ReactStripeElements } from "react-stripe-elements";

import "./cardForm.scss";

interface IState {
    complete: boolean;
    error: stripe.Error | undefined;
    fontSize: string;
}

class _CardForm extends React.PureComponent<ReactStripeElements.InjectedStripeProps, IState> {
    public state: IState = {
        complete: false,
        error: undefined,
        fontSize: this.determineFontSize(),
    };

    public render() {
        const { complete, error } = this.state;
        const disabled = !complete || error != null;
        const maybeErrorMessage = error != null && error.message != null ? error.message : "";
        return (
            <div className="scpr-CardForm card-panel">
                <form onSubmit={this.handleSubmit}>
                    <CardElement
                        className="scpr-CardForm-card-element"
                        onChange={this.handleChange}
                        {...this.getOptions()}
                    />

                    <span className="left scpr-CardForm-error-message">
                        {maybeErrorMessage}
                    </span>

                    <button
                        className={cx("btn-large waves-effect waves-light right scpr-CardForm-submit", { disabled })}
                        type="submit"
                    >
                        Save
                        <i className="material-icons right">send</i>
                    </button>
                </form>
            </div>
        );
    }

    public componentDidMount() {
        window.addEventListener("resize", this.updateFontSize);
    }

    public componentWillUnmount() {
        window.removeEventListener("resize", this.updateFontSize);
    }

    private updateFontSize = () => {
        const { fontSize } = this.state;
        const targetFontSize = this.determineFontSize();
        if (fontSize !== targetFontSize) {
            this.setState({ fontSize: targetFontSize });
        }
    };

    private determineFontSize() {
        const { innerWidth } = window;
        return innerWidth < 450 ? "14px" : "18px";
    }

    private getOptions = () => {
        const { fontSize } = this.state;
        return {
            style: {
                base: {
                    fontSize,
                    color: '#424770',
                    letterSpacing: '0.025em',
                    fontFamily: 'Source Code Pro, monospace',
                    '::placeholder': {
                        color: '#aab7c4',
                    },
                },
                invalid: {
                    color: '#9e2146',
                },
            },
        };
    };

    private handleChange = (event: stripe.elements.ElementChangeResponse) => {
        const { complete, error } = event;
        this.setState({ complete, error });
    };

    private handleSubmit = (ev: React.FormEvent) => {
        const { stripe } = this.props;

        ev.preventDefault();

        if (stripe != null) {
            stripe
                .createToken()
                .then((payload) => console.log('[token]', payload));
        } else {
            console.log("Stripe.js hasn't loaded yet.");
        }
    };
}

export const CardForm = injectStripe(_CardForm);
